import { createSlice } from "@reduxjs/toolkit";

export const mainDashBoardSlice=createSlice({
    name:"mainDashBoardSlice",
    initialState:{
        submitLoading:false,
        tableLoading:false,
        userDetails:null,
        branchDetails:null,
        currencyDetails:null,
        needsSetup:true,
    },
    reducers:{
        setSubmitLoading:(state,action)=>{
            state.submitLoading=action.payload
        },
        setTableLoadingGlobal:(state,action)=>{
            state.tableLoading=action.payload
        },
        setEmployeeDetails:(state,action)=>{
            state.userDetails=action.payload
        },
        setBranchDetails:(state,action)=>{
            state.branchDetails=action.payload
        },
        setCurrencyDetails:(state,action)=>{
            state.currencyDetails=action.payload
        },
        setNeedsSetup:(state,action)=>{
            state.needsSetup=action.payload
        },
    }
})

export const {setSubmitLoading,setCurrencyDetails,setTableLoadingGlobal,setEmployeeDetails,setBranchDetails,setNeedsSetup}=mainDashBoardSlice.actions

export default mainDashBoardSlice.reducer